<template>
  <div class="time-filter btnHover" @click="check">
    <span class="select-t" ><i class="icon iconfont iconicon_time1"></i>{{currentValue && currentValue.length > 0 ? resetTime(currentValue.join(' — ')) : '选择时间'}}</span>
    <wf-date align="center" type="daterange" value-format="yyyy-MM-dd" ref="inputLongText"  v-model="currentValue" @change="changeVal" :shortcuts="shortcuts" :pickerOptions="pickerOptions"></wf-date>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    shortcuts: {
      type: Array || String,
      default: () => ''
    },
    pickerOptions: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
    }
  },
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val || [])
      }
    }
  },
  methods: {
    changeVal(val) {
      this.$emit('change', this.currentValue || [])
    },
    check() {
      this.$refs.inputLongText.handleFocus()
    }
  }
}
</script>
<style lang="scss">
.time-filter {
  padding: 8px;
  position: relative;
  .select-t {
    color: rgba(32, 32, 32, 0.6);
    font-size: 14px;
    font-weight: 400;

    i {
      font-size: 14px;
      margin-right: 9px;
    }
  }
  .el-date-editor {
    position: absolute;
    z-index: -99999;
    visibility: hidden;
    left: 0;
    bottom: 0;
    top: 0;
    right: 0;
    width: 100%;
    height: 100% !important;
  }
}
</style>
